<template>
  <SendHistory :histories="histories" />
</template>
<script>
import SendHistory from '@/modules/tenantProjects/SendHistory'
import { useCurrentGreenFitout } from '@/modules/tenantProjects/greenFitOut/hook'
import { computed, unref } from 'vue-demi'
import { GREEN_FITOUT_HISTORY_ACTION_TYPE } from './consts'

export default {
  components: {
    SendHistory,
  },
  setup () {
    // @TODO The currentSubmission variable should support be receive a value via param
    const currentSubmission = useCurrentGreenFitout()

    return {
      histories: computed(() => {
        const allowedActionTypes = [GREEN_FITOUT_HISTORY_ACTION_TYPE.RESEND, GREEN_FITOUT_HISTORY_ACTION_TYPE.SEND]
        return (unref(currentSubmission).histories || []).filter(item => allowedActionTypes.includes(item.actionType)).map(item => {
          return {
            ...item,
            emailReceivers: item.receivers,
          }
        })
      }),
    }
  },
}
</script>
